import { SurchargeInfo } from "@/models/pricing/price";
import { SurchargeRate, SurchargeState } from "./types";

export const setSurcharge = (
  state: SurchargeState,
  value: SurchargeInfo
): void => {
  state.rate = value.rate;
  state.label = value.label;
  state.effective_date = value.effective_date;
  state.fetchedAt = Date.now();
};

/** Rate and label only: the effective date comes from the API alone */
export const seedSurcharge = (
  state: SurchargeState,
  value: SurchargeRate
): void => {
  state.rate = value.rate;
  state.label = value.label;
};
